<template>
  <form-field-select
    :label="label"
    v-model="contactNumber"
    @change="handleInput"
    :validation-errors="validationErrors"
    placeholder="There are no available numbers"
  >
    <option
      v-for="(number, index) in toNumbers"
      :key="index"
      :value="number"
      :disabled="number.is_on_dnc"
    >
      <template v-if="number.is_on_dnc">{{ number.label }} (DNC)</template>
      <template v-else>{{ number.label }}</template>
    </option>
  </form-field-select>
</template>

<script>
import FormField from "./FormField";
import {FormFieldMixin} from "./FormField.mixin";

export default {
  name: "FormFieldSelectContactNumbers",
  components: {FormField},
  mixins: [FormFieldMixin],
  props: {
    value: {},
    label: {
      type: String,
      default: "To Number"
    },
    validationErrors: {
      type: [
        String,
        Array,
        undefined
      ]
    },
    helpText: {
      type: String
    },
    size: {
      type: String,
      default: "is-small"
    },
    hasEmptyOption: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contact: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      contactNumber: null,
    };
  },
  mounted() {
    // this is here to initialize/emit the contact number on first load
    this.handleInput(this.contactNumber);
  },
  computed: {
    toNumbers() {
      let numbers = [];
      const name = this.contact.full_name !== " " ? this.contact.full_name : "unknown";

      if (this.contact.phone_1) {
        numbers.push({
          value: this.contact.phone_1,
          label: `${name}: ${this.contact.phone_1}`,
          contact_id: this.contact.id,
          is_on_dnc: this.contact.is_phone_one_on_do_not_contact_list
        });
      }

      if (this.contact.phone_2) {
        numbers.push({
          value: this.contact.phone_2,
          label: `${name}: ${this.contact.phone_2}`,
          contact_id: this.contact.id,
          is_on_dnc: this.contact.is_phone_two_on_do_not_contact_list
        });
      }

      if (this.contact.phone_3) {
        numbers.push({
          value: this.contact.phone_3,
          label: `${name}: ${this.contact.phone_3}`,
          contact_id: this.contact.id,
          is_on_dnc: this.contact.is_phone_three_on_do_not_contact_list
        });
      }

      if (this.contact.phone_4) {
        numbers.push({
          value: this.contact.phone_4,
          label: `${name}: ${this.contact.phone_4}`,
          contact_id: this.contact.id,
          is_on_dnc: this.contact.is_phone_four_on_do_not_contact_list
        });
      }

      if (this.contact.phone_5) {
        numbers.push({
          value: this.contact.phone_5,
          label: `${name}: ${this.contact.phone_5}`,
          contact_id: this.contact.id,
          is_on_dnc: this.contact.is_phone_five_on_do_not_contact_list
        });
      }

      if (this.contact.phone_6) {
        numbers.push({
          value: this.contact.phone_6,
          label: `${name}: ${this.contact.phone_6}`,
          contact_id: this.contact.id,
          is_on_dnc: this.contact.is_phone_six_on_do_not_contact_list
        });
      }

      if (this.contact.phone_7) {
        numbers.push({
          value: this.contact.phone_7,
          label: `${name}: ${this.contact.phone_7}`,
          contact_id: this.contact.id,
          is_on_dnc: this.contact.is_phone_seven_on_do_not_contact_list
        });
      }

      if (this.contact.phone_8) {
        numbers.push({
          value: this.contact.phone_8,
          label: `${name}: ${this.contact.phone_8}`,
          contact_id: this.contact.id,
          is_on_dnc: this.contact.is_phone_eight_on_do_not_contact_list
        });
      }

      if (this.contact.phone_9) {
        numbers.push({
          value: this.contact.phone_9,
          label: `${name}: ${this.contact.phone_9}`,
          contact_id: this.contact.id,
          is_on_dnc: this.contact.is_phone_nine_on_do_not_contact_list
        });
      }

      if (this.contact.phone_10) {
        numbers.push({
          value: this.contact.phone_10,
          label: `name: ${this.contact.phone_10}`,
          contact_id: this.contact.id,
          is_on_dnc: this.contact.is_phone_ten_on_do_not_contact_list
        });
      }

      const filteredNumbers = numbers.filter(number => !number.is_on_dnc);
      this.contactNumber = filteredNumbers.length ? filteredNumbers[0] : null;

      return numbers;
    },
  },
  methods: {
    handleInput(val) {
      this.$emit("input", val);
      this.$emit("change", val);
      this.$emit("selected", val);

      this.emitGlobalFieldChangeEvent();
    },
  }
};
</script>

<style lang="scss" scoped>
// Due to how Buefy works these styles must be in global styles
</style>
